/* global $ */
import { gsap } from 'gsap';
import { viewportWidth } from '../helpers/dom-tools';
/* eslint no-unused-vars: 0 */
/* eslint jsdoc/require-param: 0 */
/* eslint jsdoc/newline-after-description: 0 */
/* eslint jsdoc/check-param-names: 0 */
/* eslint jsdoc/require-param-name: 0 */
/* eslint jsdoc/check-types: 0 */
/* eslint jsdoc/require-returns-description: 0 */

const $html = $('html');
const $menuOverlay = $.$body.find('.mobile-overlay');
const $menuOverlayInner = $menuOverlay.find('.main-mobile-menu-inner');

let timeOutTimer = null;

/**
 * Menu controller for expanding mobile menu overlay
 * @type {Object}
 */
const MobileMenuController = {
	// also toggles active menu on button clicks to handle footer signup hash link
	$trigger: $.$body.find(
		'.mobile-menu-toggle__control, .utility-buttons .buttons:last-child a'
	),

	/* Main menu settings */
	settings: {
		lastScrollPosition: 0,
		vHeight: 0,
	},

	/* Animation settings */
	animate: {
		menu: {
			duration: 0,
			visible: {
				ease: 'none',
				css: {
					display: 'block',
				},
			},
			hidden: {
				ease: 'none',
				css: {
					display: 'none',
				},
			},
		},
	},

	// /**
	//  * Get initial viewport height
	//  * @return {Number}
	//  */
	// viewportHeight: function () {
	// 	return window.innerHeight;
	// },

	// /**
	//  * Wrapper to update height
	//  */
	// updateHeight: function (height) {
	// 	$menuOverlay.height(height);
	// },

	/**
	 * Init func
	 */
	init: function () {
		this.bindUI(this.$trigger);
	},

	/**
	 * Bind UI
	 * @param {Object}
	 */
	bindUI: function (trigger) {
		// this.settings.vHeight = this.viewportHeight();
		// this.updateHeight(this.settings.vHeight);
		trigger.on('click', this.handleClick);
		document.addEventListener('keyup', (ev) => {
			if (ev.keyCode === 27 && this.checkState() === true) {
				this.handleClick(ev);
			}
		});
		// $(window).resize(() => {
		// 	this.settings.vHeight = this.viewportHeight();
		// 	this.updateHeight(this.settings.vHeight);
		// });
	},

	/**
	 * Checks menu state
	 * @return {Boolean}
	 */
	checkState: function () {
		if (!$menuOverlay.hasClass('menu--active')) {
			return false;
		}
		return true;
	},

	/**
	 * Collapses alert bar on open
	 * @param {String}
	 * @param {Number}
	 */
	handleAlert: function (action, scrollPos) {
		const $alert = $('.alert-bar__top');
		const $alertBottom = $('.alert-bar__bottom');
		if (
			action === 'open' &&
			$alert &&
			scrollPos < $alert.outerHeight() + 20
		) {
			$alert.addClass('collapse');
		} else if (action === 'close' && $alert.hasClass('collapse')) {
			$alert.removeClass('collapse');
		}
		if (action === 'open' && $alertBottom) {
			$alertBottom.addClass('collapse');
		} else if (action === 'close' && $alertBottom) {
			$alertBottom.removeClass('collapse');
		}
	},

	/**
	 * Handle menu behavior on Click
	 * @param {Object}
	 */
	handleClick: function (e) {
		// e.preventDefault();
		clearTimeout(timeOutTimer);

		// Set up vars
		const _ = MobileMenuController;
		const btn = _.$trigger;

		// Set up gsap
		const tl = gsap.timeline({ paused: true });
		tl.fromTo(
			$menuOverlay,
			_.animate.menu.duration,
			_.animate.menu.hidden,
			_.animate.menu.visible
		);

		if (_.checkState() === false) {
			// to open
			_.handleAlert('open', _.settings.lastScrollPosition);
			_.settings.lastScrollPosition =
				document.documentElement.scrollTop || window.pageYOffset;
			_.$trigger.toggleClass('is-active');
			$menuOverlay.addClass('menu--active').attr('aria-hidden', 'false');
			tl.play();
			$menuOverlayInner.scrollTop(0);
			$html.addClass('noScroll mobile-menu-active');
			$.$body.css({
				overflowY: 'hidden',
				top: `-${_.settings.lastScrollPosition}px`,
			});
		} else if (_.checkState() === true) {
			// to close
			// e.stopPropagation();
			_.$trigger.toggleClass('is-active');
			_.handleAlert('close', _.settings.lastScrollPosition);
			$.$body.css({
				overflowY: 'unset',
				top: '',
			});
			$('html, body').scrollTop(_.settings.lastScrollPosition);
			$menuOverlay
				.removeClass('menu--active')
				.attr('aria-hidden', 'true');
			tl.reverse(0);
			$html.removeClass('noScroll mobile-menu-active');

			// handles email signup hash link if clicked
			timeOutTimer = setTimeout(() => {
				if (window.location.hash === '#footer_signup') {
					$('#footer_signup input.email').focus();
				}
			}, 200);
		}
	},
};

if ($menuOverlay) {
	MobileMenuController.init();
}

/**
 * Menu controller for expanding mobile menu
 * @type {Object}
 */
const MobileController = {
	$trigger: $('.primary-mobile-menu__inner').find('.menu-item-has-children'),

	animate: {
		duration: 0.35,
		visible: {
			ease: 'power1.easeOut',
			css: {
				// display: 'block',
				autoAlpha: 1,
				maxHeight: '600px',
			},
		},
		hidden: {
			ease: 'power4.easeIn',
			css: {
				maxHeight: '0px',
				// display: 'none',
				autoAlpha: 0,
			},
		},
	},
	classes: {
		active: 'expanded',
	},

	/**
	 * Init
	 */
	init: function () {
		this.bindUI();
	},

	/**
	 * Bind event listeners
	 */
	bindUI: function () {
		this.$trigger.children('.expand-trigger').on('click', this.handleClick);
	},

	/**
	 * Handle Click
	 */
	handleClick: function (e) {
		e.preventDefault();

		const _ = MobileController;
		const $this = $(this).parent();
		const $child = $this.children('.sub-menu-wrap');

		const tl = gsap.timeline({ pasued: true });
		tl.fromTo(
			$child,
			_.animate.duration,
			_.animate.hidden,
			_.animate.visible
		);

		if (!_.testState($this)) {
			$this.addClass(_.classes.active);
			tl.play();
		} else {
			$this.removeClass(_.classes.active);
			tl.reverse();
		}
	},

	/**
	 * Check if menu item is expanded
	 * @param {Object}
	 * @return {Boolean}
	 */
	testState: function (item) {
		if ($(item).hasClass(this.classes.active)) {
			return true;
		}
		return false;
	},
};

if ($menuOverlay) {
	MobileController.init();
}

$(window).on('orientationchange', function (event) {
	timeOutTimer = setTimeout(() => {
		if (viewportWidth() >= 992) {
			// Make sure we close any open mobile overlay
			if ($menuOverlay.hasClass('menu--active')) {
				MobileMenuController.handleClick();
				timeOutTimer = setTimeout(() => {
					$('.mobile-menu-toggle__control').removeClass('is-active');
				}, 200);
			}
		}
	}, 200);
});
